import { gql } from '@apollo/client';

export const GetPolicyPermissionDecision = gql`
    query GetPolicyPermissionDecision($permissionAction: String!, $permissionName: String!, $resourceUid: String!) {
  getPolicyDecision(
    permissionAction: $permissionAction
    permissionName: $permissionName
    resourceUid: $resourceUid
  ) {
    decision {
      by {
        policy {
          refId
          uid
          title
        }
      }
    }
    requestedPermission {
      action
      permission
      resource {
        uid
      }
    }
  }
}
`;
